var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#FFE379"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0005 52.5C35.0005 52.5 20.5439 47.3261 20.5439 32.413V20.163L35.0005 17.5L49.457 20.163V32.413C49.457 47.4783 35.0005 52.5 35.0005 52.5Z",
    fill: "white",
    stroke: "#3B3A40",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.0002 16.3394L50.598 19.2126V32.4129C50.598 39.3596 47.7293 44.8404 42.9768 48.9676C41.3235 50.4033 39.5556 51.5701 37.7864 52.492C36.7176 53.0489 35.8764 53.4037 35.3747 53.578L34.9945 53.71L34.5031 53.5332C34.0721 53.3717 33.4364 53.0962 32.6503 52.697L32.207 52.4669C30.4393 51.5304 28.6729 50.3515 27.021 48.9083C22.2706 44.7579 19.4023 39.2932 19.4023 32.4129V19.2126L35.0002 16.3394ZM48.3154 21.1132L35.0002 18.6602L21.685 21.1132V32.4129C21.685 38.4557 24.1348 43.2466 28.2627 46.9587L28.5228 47.1893C30.0333 48.5089 31.6551 49.5913 33.2757 50.4499C33.841 50.7494 34.3642 50.999 34.8312 51.2005L35.0047 51.2741L35.066 51.2498L35.4156 51.1007C35.8196 50.9235 36.261 50.7129 36.7316 50.4677C38.3507 49.6241 39.971 48.5546 41.4801 47.2441C45.7629 43.5248 48.3154 38.6483 48.3154 32.4129V21.1132Z",
    fill: "#3B3A40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6784 24.2449L50.3966 25.7476L35.7572 42.4867C35.3712 42.928 34.7197 43.0011 34.2481 42.6736L34.1563 42.6028L26.2793 35.8673L27.7627 34.1324L34.781 40.1342L48.6784 24.2449Z",
    fill: "#3B3A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColab);
export default __webpack_public_path__ + "static/media/colab.4b7fb0ae6ff14b43d8d256fbdad8d72d.svg";
export { ForwardRef as ReactComponent };